module.exports = __webpack_public_path__ + "img/laboratorio4_4-3.9475aa6f.jpg";